import { Chess } from "chess.js";
import { LichessResponse } from "./getOpeningBookMove";
import { LICHESS_DATA } from "./lichessData";
import { EndReason, EngineSource, Level, PlayerColor, Settings, TimeControl } from "./models";
import { END_GAME_AFTER_3_MOVES } from "./App";

const GAME_DURATION_CONTANTS = {
    short: {
        minMoves: 4,
        scaleFactor: 2,
    },
    medium: {
        minMoves: 7,
        scaleFactor: 1,
    },
    long: {
        minMoves: 7,
        scaleFactor: 0.25,
    },
    veryLong: {
        minMoves: 11,
        scaleFactor: 0.1,
    },
};

const getTotalNumberOfGamesInMillion = (engineLevel: Level, timeControls: TimeControl[]) => {
    let sum = 0;
    for (const timeControl of timeControls) {
        sum += parseInt(LICHESS_DATA[timeControl][engineLevel]);
    }

    return sum;
};

export const getShouldEndRun = (
    lichessResponse: LichessResponse,
    engineLevel: Level,
    moveNumber: number,
    moveNumberFromPosition: number,
    settings: Settings,
    turn: PlayerColor,
    playerColor: PlayerColor,
    uniquePositionAgainstPlayer: boolean,
    engineSource: EngineSource | undefined,
    game: Chess,
    isMightEndCheck?: boolean,
): { shouldEnd: boolean; endReason?: EndReason } => {
    const totalGames = lichessResponse.white + lichessResponse.black + lichessResponse.draws;
    console.log("totalGames:", totalGames);

    if (END_GAME_AFTER_3_MOVES && moveNumberFromPosition === 3) {
        return { shouldEnd: true };
    }

    if (game.isThreefoldRepetition()) {
        return { shouldEnd: true, endReason: "threefoldRepetition" };
    }

    if (engineSource === "lichessPlayer" && !uniquePositionAgainstPlayer && lichessResponse.isPlayerData) {
        return { shouldEnd: false };
    }

    if (totalGames === 0) {
        return { shouldEnd: true, endReason: "uniquePosition" };
    }

    if (settings.gameDuration === "max") {
        return { shouldEnd: false };
    }

    const fen = game.fen();
    const isEnPassentPossible = fen.split(" ")[3] !== "-";

    // To avoid the bug with chess-api.com
    if (isEnPassentPossible) {
        return { shouldEnd: false };
    }

    const { minMoves, scaleFactor } = GAME_DURATION_CONTANTS[settings.gameDuration || "medium"];

    const totalNumberOfGamesInMillion = getTotalNumberOfGamesInMillion(engineLevel, settings.timeControls);

    const thresHold = totalNumberOfGamesInMillion * scaleFactor;
    console.log("thresHold:", thresHold);

    let keepGoingByRandomness = false;
    // Should have 50 % chance of ending at move 7 to make it fair
    if (moveNumber === minMoves && turn === "w" && totalGames < thresHold) {
        keepGoingByRandomness = Math.random() > 0.5;
    }

    if (isMightEndCheck) {
        keepGoingByRandomness = false;
    }

    if (keepGoingByRandomness) {
        console.log("Continuing");
    }
    console.log();

    const shouldEnd =
        totalGames < thresHold &&
        moveNumber >= minMoves &&
        // moveNumberFromPosition >= minMoves - 1 &&
        !keepGoingByRandomness;

    if (shouldEnd && turn !== playerColor) {
        return { shouldEnd: true, endReason: "playerBelowThreshold" };
    }

    if (shouldEnd && turn === playerColor) {
        return { shouldEnd: true, endReason: "opponentBelowThreshold" };
    }

    return { shouldEnd: false };
};
